import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';
import Form from './manutencaoForm';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getOpcoes
} from './manutencaoActions';

const columns = [
    { field: 'datahora_manutencao', type: 'date' },
    { field: 'nome_veiculo', type: 'text' },
    { field: 'odometro', type: 'number' },
    { field: 'horimetro', type: 'number' },
    { field: 'descricao', type: 'text' },
    { field: 'valor_total', type: 'number' },
    { field: 'nome_usuario_inclusao', type: 'text' },
    { field: 'nome_usuario_alteracao', type: 'text' }
];

const moeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const Manutencao = props => {
    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisa, setPesquisa] = useState('');
    const [sort, setSort] = useState({
        field: 'datahora_manutencao',
        direction: 'desc'
    });

    useEffect(() => {
        props.getLista();
        props.getOpcoes();
    }, []);

    const abrir = (modo, item) => {
        props.setModoTela(modo, item);
        props.initForm(item);
    };

    const onSort = field => setSort(anterior => ({
        field,
        direction: anterior.field === field && anterior.direction === 'asc'
            ? 'desc' : 'asc'
    }));

    const termo = pesquisa.trim().toUpperCase();
    const filtrada = (props.lista || []).filter(item => {
        if (!termo) return true;
        return [
            item.nome_veiculo,
            item.descricao,
            item.nome_usuario_inclusao,
            item.nome_usuario_alteracao,
            ...(item.itens || []).map(i => i.descricao)
        ].join(' ').toUpperCase().includes(termo);
    });
    const lista = sortData(filtrada, sort, columns);
    const alturaTabela = window.innerWidth < 631
        ? window.innerHeight - 260
        : window.innerHeight - 180;

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ExcelFile.ExcelSheet;
    const ExcelColumn = ExcelFile.ExcelColumn;

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}
            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                <ContentCard>
                    <ContentCardHeader>
                        <Row>
                            <InputPesquisa
                                cols='12 6 3 1'
                                label='Pesquisar'
                                minWidth={344}
                                onChange={setPesquisa}
                            />
                            <div style={{ marginTop: 8, width: 270 }}>
                                <button
                                    type='button'
                                    className='btn btn-app bg-success'
                                    style={{ marginLeft: 2, minWidth: 75 }}
                                    onClick={() => abrir('cadastro', {})}
                                >
                                    <i className='fas fa-plus' />
                                    Adicionar
                                </button>
                                <button
                                    type='button'
                                    className='btn btn-app bg-primary'
                                    style={{ marginLeft: 2, minWidth: 75 }}
                                    onClick={() => {
                                        props.getLista();
                                        props.getOpcoes();
                                    }}
                                >
                                    <i className='fas fa-sync-alt' />
                                    Atualizar
                                </button>
                                <ExcelFile
                                    filename='Manutencoes'
                                    element={
                                        <button
                                            type='button'
                                            className='btn btn-app bg-info'
                                            style={{ marginLeft: 2, minWidth: 75 }}
                                        >
                                            <i className='fas fa-file-excel' />
                                            Exportar
                                        </button>
                                    }
                                >
                                    <ExcelSheet
                                        data={lista.map(item => ({
                                            ...item,
                                            datahora_formatada: getDataHoraFormatada(
                                                item.datahora_manutencao
                                            ),
                                            valor_total_formatado: moeda(item.valor_total),
                                            itens_formatados: (item.itens || [])
                                                .map(i => `${i.descricao}: ${moeda(i.valor)}`)
                                                .join('; ')
                                        }))}
                                        name='Manutenções'
                                    >
                                        <ExcelColumn label='Data / Hora' value='datahora_formatada' />
                                        <ExcelColumn label='Veículo' value='nome_veiculo' />
                                        <ExcelColumn label='Odômetro' value='odometro' />
                                        <ExcelColumn label='Horímetro' value='horimetro' />
                                        <ExcelColumn label='Descrição' value='descricao' />
                                        <ExcelColumn label='Itens' value='itens_formatados' />
                                        <ExcelColumn label='Valor total' value='valor_total_formatado' />
                                        <ExcelColumn
                                            label='Criado por'
                                            value='nome_usuario_inclusao'
                                        />
                                        <ExcelColumn
                                            label='Alterado por'
                                            value='nome_usuario_alteracao'
                                        />
                                    </ExcelSheet>
                                </ExcelFile>
                            </div>
                        </Row>
                    </ContentCardHeader>
                    <ContentCardBody>
                        <Table
                            responsive border alturaFixa striped
                            maxHeight={alturaTabela}
                        >
                            <THead>
                                <Tr>
                                    <ThSort field='datahora_manutencao' label='Data / Hora' width={150} sort={sort} onSort={onSort} />
                                    <ThSort field='nome_veiculo' label='Veículo' width={180} sort={sort} onSort={onSort} />
                                    <ThSort field='odometro' label='Odômetro' width={105} sort={sort} onSort={onSort} />
                                    <ThSort field='horimetro' label='Horímetro' width={105} sort={sort} onSort={onSort} />
                                    <ThSort field='descricao' label='Descrição' width={280} sort={sort} onSort={onSort} />
                                    <ThSort field='valor_total' label='Valor total' width={125} sort={sort} onSort={onSort} />
                                    <ThSort
                                        field='nome_usuario_inclusao'
                                        label='Criado por'
                                        width={170}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_usuario_alteracao'
                                        label='Alterado por'
                                        width={170}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <Th sticky alignCenter width={80} />
                                </Tr>
                            </THead>
                            <TBody>
                                {lista.map((item, index) => (
                                    <Tr
                                        key={item.id}
                                        backgroundColor={linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : index % 2 === 0 ? '#ffffff' : '#f5f5f5'}
                                    >
                                        <Td alignCenter onClick={() => setLinhaSelecionada(item.id)}>
                                            {getDataHoraFormatada(item.datahora_manutencao)}
                                        </Td>
                                        <Td alignCenter>{item.nome_veiculo}</Td>
                                        <Td alignCenter>{item.odometro === null ? '-' : FormatUtils.formatarValorTela(item.odometro, 1)}</Td>
                                        <Td alignCenter>{item.horimetro === null ? '-' : FormatUtils.formatarValorTela(item.horimetro, 1)}</Td>
                                        <Td>{item.descricao}</Td>
                                        <Td alignCenter>{moeda(item.valor_total)}</Td>
                                        <Td alignCenter>
                                            {item.nome_usuario_inclusao}
                                        </Td>
                                        <Td alignCenter>
                                            {item.nome_usuario_alteracao}
                                        </Td>
                                        <Td alignCenter minWidth={90} maxWidth={90}>
                                            <ButtonTable
                                                type='warning' width={32} small
                                                icon='fas fa-pencil-alt' visible={true}
                                                title='Editar'
                                                event={() => abrir('cadastro', item)}
                                            />
                                            <ButtonTable
                                                type='danger' width={32} small
                                                icon='fas fa-trash-alt' visible={true}
                                                title='Excluir'
                                                event={() => abrir('exclusao', item)}
                                            />
                                        </Td>
                                    </Tr>
                                ))}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCard>}
        </Content>
    );
};

const mapStateToProps = state => ({
    modoTela: state.manutencao.modoTela,
    aguardando: state.manutencao.aguardando,
    lista: state.manutencao.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getOpcoes
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Manutencao);
